import { useBoundStore } from 'useStore';
import FilterChip from 'views/Components/Forecast/FilterChip';
import useMarketplacesForCurrentCountry from 'views/Components/Shared/hooks/useMarketplacesForCurrentCountry';

export default function MarketplaceFiltersChip() {
	const selectedMarketplace = useBoundStore(
		(state) => state.fhSelectedMarketplace
	);

	const marketplacesForCurrentCountry = useMarketplacesForCurrentCountry();

	const marketplace =
		selectedMarketplace === 0
			? { marketplace_sname: 'Todos' }
			: marketplacesForCurrentCountry?.find(
					(m) => m?.marketplace_id === selectedMarketplace
			  );

	if (!marketplace) return null;

	return (
		<FilterChip
			filterName="Marketplace"
			title={marketplace?.marketplace_sname}
		/>
	);
}
